export const iconFontAwesomeLogisticsWarehouse = (
	<i className="fa-solid fa-warehouse"></i>
);
